<template>
  <div class="body" v-loading.fullscreen.lock="expressSubmitting" element-loading-text="处理中，请稍候">
    <!-- 退换货记录 -->
    <baseBreadcrumb :page="$t('message.toBePacked')" :menu="$t('message.followUpTheReplacementPackage')" />
    <div class="body">
      <div class="packing-status">
        <el-radio-group v-model="datas.action_status" @change="changePackingStatus">
          <el-radio-button label="">{{ $t("message.all") }}</el-radio-button>
          <el-radio-button label="1">{{ $t("message.toBePackedStatus") }}</el-radio-button>
          <el-radio-button label="2">{{ $t("message.packedUp") }}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="search">
        <!-- 客户ID -->
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" clearable></el-input>
        </div>
        <!-- 订单号 -->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" clearable></el-input>
        </div>
        <!-- 交易号 -->
        <div class="item">
          <el-input v-model="datas.purchase_no" :placeholder="$t('message.transactionNumber')" clearable></el-input>
        </div>
        <!-- 物流号 -->
        <div class="item">
          <el-input v-model="datas.refund_express_no" :placeholder="$t('message.logisticsNumber')" clearable></el-input>
        </div>
        <!-- 开始日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="['23:59:59']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 采购 -->
        <div class="item">
          <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>

        <!-- 配货员 -->
        <div class="item">
          <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 退换货 -->
        <div class="item">
          <el-select v-model="datas.refund_type" clearable filterable :placeholder="$t('message.returnAndExchange')">
            <el-option label="换货" value="2"></el-option>
            <el-option label="退货" value="1"></el-option>
          </el-select>
        </div>
        <!-- 按钮 -->
        <div class="item">
          <el-button type="primary" @click="search">
            {{ $t("message.filter") }}
          </el-button>
          <!-- 批量打印 -->
          <el-button @click="batchPrint" type="success">{{ $t("message.batchPrint") }}</el-button>
        </div>
        <!-- 批量填写退货物流号 -->
        <div class="item">
          <el-button @click="batchFillReturnTrackingNumber" type="success">{{ $t("message.batchExpressUpdate")
          }}</el-button>
        </div>
        <!-- 批量修改退货物流号 -->
        <!-- <div class="item">
          <el-button @click="batchUpdateReturnTrackingNumber" type="primary">批量修改退货物流号</el-button>
        </div> -->
        <!-- 批量删除退货物流号 -->
        <!-- <div class="item">
          <el-button @click="batchDeleteReturnTrackingNumber" type="danger">批量删除退货物流号</el-button>
        </div> -->
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" v-if="show"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="60" align="center"></el-table-column>
          <el-table-column align="center" label="NO" prop="rowNumber" width="60">
          </el-table-column>
          <!--  退换货编号-->
          <el-table-column align="center" :label="$t('message.returnAndExchangeNumber')" prop="refund_sn" width="150px">
          </el-table-column>
          <!--  打包时间-->
          <!-- <el-table-column align="center" :label="$t('message.packingTimeDB')" prop="pack_at" width="100px">
          </el-table-column> -->
          <!--  提出时间-->
          <el-table-column align="center" :label="$t('message.forwardTime')" prop="created_at" width="100px">
          </el-table-column>
          <!--  采购员-->
          <el-table-column align="center" :label="$t('message.buyer')" prop="g_admin.realname" width="100">
          </el-table-column>
          <!--  配货员-->
          <el-table-column align="center" :label="$t('message.distributionMember')" prop="p_admin.realname" width="100">
          </el-table-column>
          <!--  订单号-->
          <el-table-column align="center" :label="$t('message.orderNumber')" prop="" width="170px">
            <template slot-scope="scope">
              <p>
                <router-link :to="'/orderPaymentDetail?order_sn=' + scope.row.order_sn" target="_blank"
                  style="color: #fa5058">{{ scope.row.order_sn }}</router-link>
              </p>
              <!-- <p>
                {{
                  scope.row.order_purchase_refund_detail.order_purchase.realname
                }}
              </p> -->
            </template>
          </el-table-column>
          <!--  交易号-->
          <el-table-column align="center" :label="$t('message.transactionNumber')" prop="purchase_no">
          </el-table-column>
          <!--  退换货类别-->
          <el-table-column align="center" :label="$t('message.typeOfReturnOrExchange')" prop="type_name" width="110px">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.refund_type == 1 ? '#FA5058' : '#2C96E7', }">{{ scope.row.type_name
              }}</span>
            </template>
          </el-table-column>
          <!--  退换货数量-->
          <el-table-column align="center" :label="$t('message.quantityOfReturnAndReplacement')" prop="refund_num_total"
            width="110px">
          </el-table-column>
          <!-- 打包状态 -->
          <el-table-column align="center" :label="$t('message.packingStatus')" prop="action_status" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.action_status == '1'" class="packing-status-value waiting">
                {{ $t("message.toBePackedStatus") }}
              </span>
              <span v-else-if="scope.row.action_status == '2'" class="packing-status-value packed">
                {{ $t("message.packedUp") }}
              </span>
            </template>
          </el-table-column>
          <!--  商品明细-->
          <el-table-column align="center" :label="$t('message.detailsOfGoods')" prop="rowNumber">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="look(scope.row)">
                {{ $t("message.look") }}
              </el-button>
            </template>
          </el-table-column>
          <!--  退换货物流号-->
          <el-table-column align="center" :label="$t('message.returnAndExchangeLogisticsNumber')" prop="rowNumber">
            <template slot-scope="scope">
              <div class="template">
                <p v-for="(express, expressIndex) in scope.row.order_purchase_refund_detail_express" :key="expressIndex"
                  style="display: flex;justify-content: space-between;">
                  <span>
                    {{ express.refund_express_no }}
                  </span>
                  <!-- 已扫描 -->
                  <span v-if="express.scan_at" style="color: #67C23A;">{{ $t('message.scanned') }}</span>
                  <span v-else style="color: #fa5058;"> {{ $t('message.unscan') }}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <!--  操作-->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="110px">
            <template slot-scope="scope">
              <!-- 打包 -->
              <p>
                <el-button size="small" type="success" @click="markPacked(scope.row.refund_sn)" v-if="isAuth(287) && scope.row.action_status == '1'">
                  {{ $t("message.pack") }}
                </el-button>
              </p>
              <p v-if="scope.row.action_status == '2' && isAuth(748)">
                <el-button size="small" type="danger" @click="openDirectComplete(scope.row.refund_sn)">
                  {{ $t("message.completeDirectly") }}
                </el-button>
              </p>
              <p>
                <el-button size="small" type="success" class="primary" @click="print(scope.row)">
                  {{ $t("message.print") }}
                </el-button>

              </p>
              <!-- 修改 -->
              <p>
                <el-button size="small" type="success" class="primary" @click="edit(scope.row)" v-if="isAuth(285)">
                  {{ $t("message.edit") }}
                </el-button>
              </p>
              <!-- 删除 -->
              <p>
                <el-button size="small" type="success" class="dark" @click="refundDelete(scope.row.refund_sn)"
                  v-if="isAuth(286)">
                  {{ $t("message.delete") }}
                </el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 打印退货唛头 -->
    <div v-show="false">
      <returnLabel ref="returnLabel" :printData="printData" />
    </div>

    <!-- 查看商品详情 -->
    <detailsGoodsDialogVisible :list="itemData" v-if="detailsGoodsDialogVisible" />
    <!-- 退换货编辑 -->
    <returnAndExchangeEditor v-if="returnAndExchangeEditorDialogVisible" :itemData="itemData" :type="1" />
    <!-- 退换货直接完成 -->
    <directComplete ref="directComplete" @success="refundList" />

    <!-- 批量填写退货物流号 -->
    <el-dialog title="批量填写退货物流号" :visible.sync="dialogVisible" width="400px" center :close-on-click-modal="false">

      <el-form :model="refundData" ref="form" label-width="80px">
        <el-form-item label="物流号" prop="refund_express_no">
          <el-input v-model="refundData.express_no" placeholder="请输入退货物流号" />
        </el-form-item>
      </el-form>
      <template slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="batchExpressUpdate">{{
          $t("message.confirm")
        }}</el-button>
      </template>
    </el-dialog>

    <!-- 批量修改退货物流号 -->
    <el-dialog title="批量修改退货物流号" :visible.sync="batchUpdateExpressVisible" width="560px" center
      :close-on-click-modal="false" :close-on-press-escape="!expressSubmitting" :show-close="!expressSubmitting">
      <div class="express-dialog">
        <div class="express-list-title">请选择需要修改的物流号：</div>
        <el-checkbox-group v-model="checkedExpressKeys" class="express-list" :disabled="expressSubmitting">
          <el-checkbox v-for="item in batchExpressList" :key="item.key" :label="item.key">
            <span>{{ item.refund_express_no }}</span>
            <span class="express-extra">({{ item.refund_sn }} / {{ item.purchase_no || '-' }})</span>
          </el-checkbox>
        </el-checkbox-group>
        <div class="new-express">
          <span>新物流号：</span>
          <el-input v-model="batchExpressForm.new_express_no" :disabled="expressSubmitting" placeholder="请输入新的退货物流号" />
        </div>
        <el-progress v-if="expressSubmitting || expressProgressTotal" :percentage="expressProgressPercentage"
          :format="formatExpressProgress"></el-progress>
      </div>
      <template slot="footer" class="dialog-footer">
        <el-button :disabled="expressSubmitting" @click="batchUpdateExpressVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <el-button type="primary" :loading="expressSubmitting" @click="submitBatchUpdateExpress">
          {{ $t("message.confirm") }}
        </el-button>
      </template>
    </el-dialog>

    <!-- 批量删除退货物流号 -->
    <el-dialog title="批量删除退货物流号" :visible.sync="batchDeleteExpressVisible" width="560px" center
      :close-on-click-modal="false" :close-on-press-escape="!expressSubmitting" :show-close="!expressSubmitting">
      <div class="express-dialog">
        <div class="express-list-title">请选择需要删除的物流号：</div>
        <el-checkbox-group v-model="checkedExpressKeys" class="express-list" :disabled="expressSubmitting">
          <el-checkbox v-for="item in batchExpressList" :key="item.key" :label="item.key">
            <span>{{ item.refund_express_no }}</span>
            <span class="express-extra">({{ item.refund_sn }} / {{ item.purchase_no || '-' }})</span>
          </el-checkbox>
        </el-checkbox-group>
        <el-progress v-if="expressSubmitting || expressProgressTotal" :percentage="expressProgressPercentage"
          :format="formatExpressProgress"></el-progress>
      </div>
      <template slot="footer" class="dialog-footer">
        <el-button :disabled="expressSubmitting" @click="batchDeleteExpressVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <el-button type="danger" :loading="expressSubmitting" @click="submitBatchDeleteExpress">
          {{ $t("message.confirm") }}
        </el-button>
      </template>
    </el-dialog>

  </div>
</template>
<script>
import detailsGoodsDialogVisible from "../components/goodsDetails";
import returnAndExchangeEditor from "../components/returnAndExchangeEditor";
import returnLabel from '../../../../components/Printedsheet/returnLabel'
import directComplete from "../components/directComplete";

function getDefaultActionStatus() {
  const workType = Number(localStorage.getItem("japanUserRoleStatus"));
  if (workType === 5) return "1";
  if (workType === 2) return "2";
  return "";
}

export default {
  data() {
    return {

      val: "",
      tableData: [],
      show: true,
      datas: {
        page: 1,
        pageSize: 10,
        status: 10,
        action_status: getDefaultActionStatus(),
        order_sn: "",
        purchase_no: "",
        dateStart: "",
        dateEnd: "",
      },
      total: 0,
      detailsGoodsDialogVisible: false,
      returnAndExchangeEditorDialogVisible: false,
      itemData: [],
      printData: [],
      dialogVisible: false,
      refundData: {
        express_no: "",
        refund_sns: []
      },// 批量填写退货物流号
      batchUpdateExpressVisible: false,
      batchDeleteExpressVisible: false,
      batchExpressList: [],
      checkedExpressKeys: [],
      batchExpressForm: {
        new_express_no: "",
      },
      expressSubmitting: false,
      expressProgressDone: 0,
      expressProgressTotal: 0,
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
    selectedBatchExpressList() {
      return this.batchExpressList.filter(item => this.checkedExpressKeys.includes(item.key));
    },
    expressProgressPercentage() {
      if (!this.expressProgressTotal) return 0;
      return Math.round((this.expressProgressDone / this.expressProgressTotal) * 100);
    },

  },
  components: {
    detailsGoodsDialogVisible,
    returnAndExchangeEditor,
    returnLabel,
    directComplete
  },
  created() {
    this.refundList();

  },
  methods: {
    refundList() {
      this.multipleSelection = []
      this.$api.signInApi.refundList(this.datas).then((res) => {
        res.data.data.forEach(item => {
          item.order_purchase_refund_detail_express = []
          item.order_purchase_refund_detail.forEach(items => {
            item.order_purchase_refund_detail_express = [...item.order_purchase_refund_detail_express, ...items.order_purchase_refund_detail_express]
          })
          // 数组去重
          var hash = {};
          item.order_purchase_refund_detail_express = item.order_purchase_refund_detail_express.reduce(function (items, next) {
            hash[next.refund_express_no]
              ? ""
              : (hash[next.refund_express_no] = true && items.push(next));
            return items;
          }, []);
        })

        this.tableData = res.data.data;
        this.total = res.data.total;

        // console.log(this.tableData);
      });
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.refundList();
    },
    // 按工种默认展示对应状态，手动切换时仅更新状态筛选
    changePackingStatus() {
      this.datas.page = 1;
      this.refundList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 10,
        status: 10,
        action_status: getDefaultActionStatus(),
        order_sn: "",
        purchase_no: "",
        dateStart: "",
        dateEnd: "",
      };
      this.refundList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.refundList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.refundList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 查看
    look(item) {
      this.itemData = JSON.parse(
        JSON.stringify(item.order_purchase_refund_detail)
      );
      this.detailsGoodsDialogVisible = true;
    },
    // 编辑
    edit(item) {
      this.itemData = JSON.parse(JSON.stringify(item));
      this.returnAndExchangeEditorDialogVisible = true;
    },
    // -打包
    markPacked(refund_sn) {
      this.$confirm(
        this.$t("message.whetherToConfirmThePackage"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.signInApi.batchMarkPacked({ refund_sns: [refund_sn] }).then((res) => {
            this.$message.success(res.msg);
            this.refundList();
          });
        })
        .catch(() => { });
    },
    openDirectComplete(refund_sn) {
      this.$refs.directComplete.open(refund_sn);
    },
    // -删除
    refundDelete(refund_sn) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.signInApi.refundDelete({ refund_sn }).then((res) => {
            this.$message.success(res.msg);
            this.refundList();
          });
        })
        .catch(() => { });
    },
    // 打印
    print(item) {
      this.printData = [item]
      this.$nextTick(() => {
        console.log(this.printData);

        this.$print(this.$refs.returnLabel);
      })

    },
    setPrintData(list) {
      list.forEach(item => {
        console.log(item);

      })
      return list
    },
    //批量打印 
    batchPrint() {
      if (this.multipleSelection == false) return this.$message.error('请选择要打印的列表')
      this.printData = this.multipleSelection
      this.$nextTick(() => {
        this.$print(this.$refs.returnLabel);
      })
    },
    // 批量填写退货物流号
    batchFillReturnTrackingNumber() {
      if (this.multipleSelection == false) return this.$message.error('请选择要填写退货物流号的列表')
      this.refundData.refund_sns = this.multipleSelection.map(item => item.refund_sn)
      this.refundData.express_no = ''
      this.dialogVisible = true

    },
    // 批量填写退货物流号
    batchExpressUpdate() {
      if (this.refundData.express_no.trim() == '') return this.$message.error('请填写退货物流号')
      this.$api.signInApi.batchExpressUpdate(this.refundData).then((res) => {
        this.$message.success(res.msg);
        this.refundList();
        this.dialogVisible = false
      });


    },
    // 批量修改退货物流号
    batchUpdateReturnTrackingNumber() {
      if (this.multipleSelection == false) return this.$message.error('请选择要修改退货物流号的列表')
      this.openBatchExpressDialog('update')
    },
    // 批量删除退货物流号
    batchDeleteReturnTrackingNumber() {
      if (this.multipleSelection == false) return this.$message.error('请选择要删除退货物流号的列表')
      this.openBatchExpressDialog('delete')
    },
    openBatchExpressDialog(type) {
      this.batchExpressList = this.getSelectedExpressList()
      if (this.batchExpressList == false) return this.$message.error('无可以操作的退货物流号')
      this.checkedExpressKeys = this.batchExpressList.map(item => item.key)
      this.batchExpressForm.new_express_no = ''
      this.expressProgressDone = 0
      this.expressProgressTotal = 0
      if (type === 'update') {
        this.batchUpdateExpressVisible = true
      } else {
        this.batchDeleteExpressVisible = true
      }
    },
    getSelectedExpressList() {
      let list = []
      this.multipleSelection.forEach(row => {
        if (Array.isArray(row.order_purchase_refund_detail)) {
          row.order_purchase_refund_detail.forEach(detail => {
            if (Array.isArray(detail.order_purchase_refund_detail_express)) {
              detail.order_purchase_refund_detail_express.forEach((express, expressIndex) => {
                if (express.refund_express_no) {
                  list.push({
                    key: `${row.refund_sn}_${detail.id}_${express.id || expressIndex}_${express.refund_express_no}`,
                    refund_sn: row.refund_sn,
                    refund_type: row.refund_type,
                    refund_detail_id: detail.id,
                    purchase_no: row.purchase_no,
                    refund_express_no: express.refund_express_no,
                  })
                }
              })
            }
          })
        }
      })
      return list
    },
    getRefundExpressPayload(row, handler) {
      let list = []
      row.order_purchase_refund_detail.forEach(detail => {
        if (Array.isArray(detail.order_purchase_refund_detail_express)) {
          detail.order_purchase_refund_detail_express.forEach((express, expressIndex) => {
            if (!express.refund_express_no) return
            const key = `${row.refund_sn}_${detail.id}_${express.id || expressIndex}_${express.refund_express_no}`
            const nextExpressNo = handler(key, express.refund_express_no)
            if (nextExpressNo) {
              list.push({
                refund_detail_id: detail.id,
                refund_express_no: nextExpressNo,
              })
            }
          })
        }
      })
      return {
        refund_sn: row.refund_sn,
        refund_type: row.refund_type,
        list,
      }
    },
    getRowsBySelectedExpress() {
      const selectedKeys = new Set(this.checkedExpressKeys)
      return this.multipleSelection.filter(row => this.batchExpressList.some(item =>
        selectedKeys.has(item.key) && item.refund_sn === row.refund_sn
      ))
    },
    formatExpressProgress() {
      return `${this.expressProgressDone}/${this.expressProgressTotal}`
    },
    async submitBatchUpdateExpress() {
      if (this.selectedBatchExpressList == false) return this.$message.error('请选择要修改的退货物流号')
      if (this.batchExpressForm.new_express_no.trim() == '') return this.$message.error('请输入新的退货物流号')
      const selectedKeys = new Set(this.checkedExpressKeys)
      const rows = this.getRowsBySelectedExpress()
      this.expressSubmitting = true
      this.expressProgressDone = 0
      this.expressProgressTotal = rows.length
      let res = null
      try {
        for (const row of rows) {
          const data = this.getRefundExpressPayload(row, (key, expressNo) =>
            selectedKeys.has(key) ? this.batchExpressForm.new_express_no.trim() : expressNo
          )
          res = await this.$api.signInApi.expressUpdate(data)
          this.expressProgressDone += 1
        }
        this.$message.success(res.msg)
        this.batchUpdateExpressVisible = false
        this.refundList()
      } finally {
        this.expressSubmitting = false
      }
    },
    async submitBatchDeleteExpress() {
      if (this.selectedBatchExpressList == false) return this.$message.error('请选择要删除的退货物流号')
      const selectedKeys = new Set(this.checkedExpressKeys)
      const rows = this.getRowsBySelectedExpress()
      this.expressSubmitting = true
      this.expressProgressDone = 0
      this.expressProgressTotal = rows.length
      let res = null
      try {
        for (const row of rows) {
          const data = this.getRefundExpressPayload(row, (key, expressNo) =>
            selectedKeys.has(key) ? '' : expressNo
          )
          res = await this.$api.signInApi.expressUpdate(data)
          this.expressProgressDone += 1
        }
        this.$message.success(res.msg)
        this.batchDeleteExpressVisible = false
        this.refundList()
      } finally {
        this.expressSubmitting = false
      }
    },
  },

};
</script>
<style lang='scss' scoped>
.packing-status {
  margin-bottom: 20px;
}

.packing-status-value.waiting {
  color: #fa5058;
}

.packing-status-value.packed {
  color: #67c23a;
}

.search {
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 200px;
    margin-right: 20px;
    margin-bottom: 20px;

    /deep/.el-date-editor {
      width: 200px;
    }
  }
}

.table {
  p {
    margin-bottom: 5px;

    .el-button {
      width: 80px;
    }
  }
}

.express-dialog {
  .express-list-title {
    margin-bottom: 10px;
    color: #606266;
  }

  .express-list {
    max-height: 320px;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 8px 12px;
    margin-bottom: 16px;

    /deep/.el-checkbox {
      display: block;
      margin: 0 0 8px;
      line-height: 24px;
    }

    .express-extra {
      color: #909399;
      margin-left: 6px;
    }
  }

  .new-express {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    span {
      width: 90px;
      flex-shrink: 0;
    }
  }
}
</style>
